var map = {
	"./ar.json": 752,
	"./en.json": 753,
	"./localise_stf/ar.json": 354,
	"./localise_stf/en.json": 355,
	"./menu_ar.json": 356,
	"./menu_en.json": 357,
	"./menu_kw_ar.json": 267,
	"./menu_kw_en.json": 268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 751;